import React from 'react';
import s from './s.module.less';
import { Button } from 'antd';
import Image2 from './images/2.png';

interface IProps {
    onClosePopup: () => void;
    onFinishFlow: () => void;
}

const Modal1 = ({
    onClosePopup,
    onFinishFlow,
}: IProps) => {
    return (
        <div className={s.wrap}>
            <div className={s.playerBox}>
                <div className={s.closeIcon} onClick={onClosePopup} />
                <div className={s.player}>
                    <img src={Image2} alt="" />
                </div>
            </div>
            <div className={s.content}>
                <div className={`${s.title}`}>Get started in 4 simple steps</div>
                <div className={s.desc}>It’s easy to set up and start seeing patients. Just follow four quick steps—no complex tools, no long forms. You’re minutes away from growing your practice with confidence.</div>
            </div>
            <div className={s.footer}>
                <div className={s.btns}>
                    <Button
                        type="primary"
                        onClick={() => {
                            onFinishFlow();
                        }}
                    >Get started
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Modal1;
